export default __webpack_public_path__ + "locales/sr-Cyrl-RS/InviteDialog.json?hash=6f3c51eb8b666d83567c6b22b1062f88";